import { StyleSheet } from 'react-native'

export const MIN_HEADER_HEIGHT = 50
export const MIN_ROW_HEIGHT = 55

export const sharedStyles = StyleSheet.create({
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: MIN_HEADER_HEIGHT,
    overflow: 'hidden',
  },
  headerCell: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 20,
    paddingTop: 15,
    padding: 10,
  },
  headerText: {
    fontSize: 13,
    fontWeight: '600',
    lineHeight: 15.25,
  },
})
